import styled from "styled-components";
import {Image} from "semantic-ui-react";
import {Link, useLocation} from "react-router-dom";
import React, {useEffect, useMemo} from "react";
import {FormProvider, useForm} from "react-hook-form";
import {useSearchParams} from "../../hooks/useSearchParams";
import {getChampionships} from "../../../data/data";
import {useFilters, useGlobalFilter, usePagination, useSortBy, useTable} from "react-table";
import {device} from "../../../theme";
import InputWithLabel from "../../inputs/InputWithLabel";
import ChampionshipsTable from "./ChampionshipsTable";
import {Menu} from "../../layout/Menu";

const championships = getChampionships();

export const Championships = () => {
    const methods = useForm();
    const {setParam, queryParams} = useSearchParams();
    const location = useLocation();
    const filterFields = useMemo(() => [""], [])

    useEffect(() => {
        resetAllFilters();

        queryParams.forEach((value, key) => {
            if (key === "search") {
                setGlobalFilter(value);
                methods.setValue("search", value);
                return;
            }
            if (!filterFields.includes(key)) return;
            setFilter(key, value || undefined);
        });
    }, [location]);

    function resetAllFilters() {
        setAllFilters([]);
    }

    const data = useMemo(() => championships.map(({id, name, year}) => ({id, name, year})), [championships]);

    const columns = useMemo(() => [
        {
            Header: "Navn",
            accessor: "name",
            disableFilters: true
        },
        {
            Header: "År",
            accessor: "year",
            disableFilters: true
        }
    ], data)

    const search = methods.watch("search");

    const initialState = useMemo(() => {
        return {
            pageSize: 10,
            sortBy: [
                {
                    id: 'year',
                    desc: true
                },
            ]
        }
    }, []);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        rows,

        previousPage,
        canPreviousPage,
        nextPage,
        canNextPage,
        gotoPage,
        pageOptions,
        pageCount,

        setFilter,
        setAllFilters,
        setGlobalFilter,
        state: {pageIndex},
    } = useTable(
        {columns, data, initialState},
        useGlobalFilter,
        useFilters,
        useSortBy,
        usePagination
    );

    useEffect(() => {
        if (search !== undefined) {
            setGlobalFilter(search)
            setParam("search", search)
        }
    }, [search]);

    return <>
        <Header>
            <div>
                <a href="https://nsff.no"><Image src={"/resultater/images/logo-darkgreen.png"} alt="Logo"
                                                 height={"60"}/></a>

            </div>
            <div>
                Mesterskap
            </div>
            <div>

            </div>
        </Header>
        <Menu/>
        <MainArea>
            <Container>
                <FormProvider {...methods}>
                    <SearchInput
                        name="search"
                        label={"Skriv inn mesterskap"}
                        autoComplete="off"
                    />
                    <ChampionshipsTable
                        getTableProps={getTableProps}
                        headerGroups={headerGroups}
                        getTableBodyProps={getTableBodyProps}
                        page={page}
                        prepareRow={prepareRow}
                        pageCount={pageCount}
                        previousPage={previousPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        canNextPage={canNextPage}
                        pageOptions={pageOptions}
                        gotoPage={gotoPage}
                        pageIndex={pageIndex}
                        isLoading={false}
                        rows={rows}
                    />
                </FormProvider>
            </Container>
        </MainArea>
    </>
}

const Container = styled.div`
  opacity: 0;
  animation: fadeIn 300ms ease forwards;
`;

const MainArea = styled.div`
  padding: 1.25rem 2.5rem 3.125rem 3.125rem;

  @media ${device.mobile} {
    padding: 1.25rem 0.625rem 3.125rem 0.625rem;
  }
`;

const SearchInput = styled(InputWithLabel)`
  flex-grow: 1;
  max-width: 27rem;
  margin-right: 1rem;
`;

const Header = styled.div`
  height: 70px;
  background-color: #90b361;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #36501c;
  font-family: 'Fibon Neue';

  > div {
    display: flex;
    flex-direction: row;
    margin-left: 10px;

    > div {
      margin-left: 20px;
    }

    > a {
      color: ${(p) => p.theme.color.primary.base};
    }

    align-items: center;
  }

  > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    font-size: 1.4rem;
  }

  > div:nth-child(3) {
    margin-right: 20px;

    > a {
      color: ${(p) => p.theme.color.primary.base};
    }
  }
`